import { render } from "./z-team.vue?vue&type=template&id=5fc1ea90"
import script from "./z-team.vue?vue&type=script&lang=js"
export * from "./z-team.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__